import { General } from "../../siteManagement/general.js";
import { AppHelper } from "../appHelper.js";
import { FieldInstance } from "../core/components/field.js";
import { Grid } from "../core/components/grid.js";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { CommonApp } from "../core/components/commonApp.js";
import { DateTimePicker } from "../core/components/dateTimePicker.js";
import React from "react";
export class ChangeNoticeApp extends React.Component<ChangeNoticeAppProps, {
    GridData: any[];
    Start: Date;
    End: Date;
}>{
    private _factory = ComponentHelper.createFactory();
    common = new AppHelper();
    private _gridOptions = {
        dataSource: {
            group: [
                {
                    field: "Index1",
                    dir: "asc"
                },
                {
                    field: "Index2",
                    dir: "asc"
                }
            ],
            schema: {
                model: {
                    fields: {
                        Wann: { type: "date" }
                    }
                }
            },
        },
        sortable: true,
        pageable: true,
        groupable: true,
        filterable: true,
        selectable: true,
        resizable: true,
        columns: [
            {
                field: "Wann",
                title: Helper.getTranslation("WebSMS.Log.Wann"),
                template: "#= kendo.toString(kendo.parseDate(Wann), 'G') #",
                width: 80
            },
            {
                field: "TranslationColumn",
                title: Helper.getTranslation("WebSMS.Log.Spaltenname"),
                width: 80
            },
            {
                field: "Index1",
                title: Helper.getTranslation("Field.Einsatz.projnr"),
                width: 100,
                template: "<a href=#= Innosoft.Config.baseUrl#ResourcePlanning/Edit?projnr=#=encodeURIComponent(Index1)#&pindex=#=encodeURIComponent(Index2)# target='_blank'>#=data.Index1#</a>"
            },
            {
                field: "Index2",
                title: Helper.getTranslation("Field.Einsatz.pindex"),
                width: 80
            },
            {
                field: "Altwert",
                title: Helper.getTranslation("WebSMS.Log.Altwert"),
                width: 120
            },
            {
                field: "Neuwert",
                title: Helper.getTranslation("WebSMS.Log.Neuwert"),
                width: 120
            },
            {
                field: "Wer",
                title: Helper.getTranslation("WebSMS.Log.Wer"),
                width: 80
            }
        ]
    };


    constructor(props: any) {
        super(props);
        this.common.init(this);
        let startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        let endDate = new Date();
        endDate.setHours(23, 59, 0, 0);
        this.state = {
            GridData: null,
            Start: startDate,
            End: endDate
        }
    }

    componentDidMount() {
        this.loadData();
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.setTitle(Helper.getTranslation("Einsatz.ChangeNotice"));
    }

    private loadData = async () => {
        let result = await HTTPService.get<JsonResultClass<any[]>>("LogAssignments/GetAssignmentsLogSummaryEntries?start=" + Helper.dates.getISODateString(this.state.Start)
            + "&end=" + Helper.dates.getISODateString(this.state.End));
        if (result.Code == 0) {
            this.setState({ GridData: result.Data });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.RELOAD) {
            this.loadData();
        }
    }

    onSelectionChanged = (dataItem) => {
        if (Helper.hasValue(dataItem)) {
            let item = dataItem;
            let baseText = difflib.stringAsLines(item.Altwert === null ? "" : item.Altwert);
            let newText = difflib.stringAsLines(item.Neuwert === null ? "" : item.Neuwert);

            let sm = new difflib.SequenceMatcher(baseText, newText);
            let opcodes = sm.get_opcodes();

            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(Helper.getTranslation("WebSMS.Log.Differenz"));
            sheet.show(() => {
                sheet.appendStringContent(diffview.buildView({
                    baseTextLines: baseText,
                    newTextLines: newText,
                    opcodes: opcodes,
                    baseTextName: Helper.getTranslation("WebSMS.Log.Altwert"),
                    newTextName: Helper.getTranslation("WebSMS.Log.Neuwert"),
                    contextSize: null,
                    viewType: 0
                }));
            });
        }
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.RELOAD, caption: Helper.getTranslation("MonitorBaum.NeuLaden"), enabled: true });
        return <Grid data={this.state.GridData} options={this._gridOptions} id="changeNotice"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.onSelectionChanged} />;
    }

    private getDateTimePickerStart = () => {
        const props = this._factory.getDefaultDateTimePickerProps();
        props.value = this.state.Start;
        props.onChange = (_, value: Date) => {
            this.setState({ Start: value });
        }
        props.field.required = false;
        return (
            <FieldInstance label={Helper.getTranslation("Auftrag.Start")} noHover={true} labelStyle={{ width: "auto" }}>
                <div style={{ width: "fit-content" }}>
                    <DateTimePicker {...props} />
                </div>
            </FieldInstance>
        );
    }

    private getDateTimePickerEnd = () => {
        const props = this._factory.getDefaultDateTimePickerProps();
        props.value = this.state.End;
        props.onChange = (_, value: Date) => {
            this.setState({ End: value });
        }
        props.field.required = false;
        return (
            <FieldInstance label={Helper.getTranslation("Auftrag.Ende")} noHover={true} labelStyle={{ width: "auto" }}>
                <div style={{ width: "fit-content" }}>
                    <DateTimePicker {...props} />
                </div>
            </FieldInstance>
        );
    }

    createComp = () => {
        let start = this.getDateTimePickerStart();
        let end = this.getDateTimePickerEnd();
        let grid = Helper.hasValue(this.state.GridData) ? this.createGrid() : null;
        return (<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "row" }}>
                {start}
                {end}
            </div>
            {grid}
        </div>);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}

interface ChangeNoticeAppProps {
}